import AuscultationRecording from 'pages/Auscultation/AuscultationRecording';

export default function HeartAuscultation() {
  return <AuscultationRecording type="heart" />;
}
